module.exports = __webpack_public_path__ + "img/showImg-1.2a6bda93.jpg";